import styled from "@emotion/styled";
import { WalletIcon } from "components/Icons";
import { useDisconnectInternal } from "hooks/useDisconnectInternal";
import { useIsMobile } from "hooks/useDeviceType";

export const ProfileActionsDisconnectButton = () => {
  const disconnect = useDisconnectInternal();
  const isMobile = useIsMobile();

  return (
    <ButtonContainer onClick={disconnect} isMobile={isMobile}>
      <WalletIcon width={20} height={20} /> Disconnect wallet
    </ButtonContainer>
  );
};

// Sub-components

const ButtonContainer = styled.button<{ isMobile: boolean }>`
  display: flex;
  padding: ${props => (props.isMobile ? "13px 16px 13px 10px" : "10px 14px 10px 8px")};
  justify-content: center;
  align-items: center;
  gap: 2px;
  flex: 1 0 0;
  border-radius: 14px;
  background: ${props => props.theme.button.secondary.surface.default};
  font-size: ${props => props.theme.fontSize[5]};
  border: none;
  color: ${props => props.theme.button.secondary.text.default};
  margin-top: 8px;
  width: 100%;
  height: ${props => (props.isMobile ? "48px" : "40px")};
  font-weight: ${props => props.theme.fontWeights["work-sans-0"]};
  line-height: ${props => props.theme.lineHeights[2]};

  &:hover {
    background: ${props => props.theme.button.secondary.surface.hover};
    color: ${props => props.theme.button.secondary.text.hover};
  }
`;
